import { useState, useEffect } from 'react'
import isEqual from 'lodash/isEqual'

import useAuthentication from './useAuthentication';

const CACHE_MINUTES = 1

const useUsergroupManagement = () => {
    const localStorageKey = 'usergroups'
    const localStorageData = localStorage.getItem(localStorageKey) ? JSON.parse(localStorage.getItem(localStorageKey)) : {}
    const [lastUpdated, _setLastUpdated] = useState(localStorageData?.lastUpdated || 0)
    const [usergroups, _setUsergroups] = useState(localStorageData?.results || [])

    const { isAuthenticated } = useAuthentication();

    useEffect(() => {
        const shouldClearCache = lastUpdated + (1000 * 60 * CACHE_MINUTES) < Date.now();

        if(!isAuthenticated) {
            return;
        }
        
        if(usergroups.length === 0 || shouldClearCache) {
            fetchData();
        }
    }, [])

    // If we're been making updates to the state on a page, and user then press Save, update the localStorage
    const saveUsergroupUpdates = () => {
        localStorage.setItem(localStorageKey, JSON.stringify({
            lastUpdated: lastUpdated,
            results: usergroups,
        }))
    }
    
    const updateUsergroup = (id, groupData) => {
        const updated = usergroups.map(i => {
            if( i.id === id ) {
                return { ...i, ...groupData }
            }
            //else
            return i
        })
        _setUsergroups(updated)
    }
    
    const fetchData = async() => {
        try {
            const response = await fetch('/v0/usergroups', { credentials: 'same-origin' });

            if (response.status === 403) {
                // They're logged out server-side; make sure that's true on client too
                //dispatch(logout())
                throw new Error(response.statusText);
            }

            const json = await response.json();

            if (json.error) {
                throw new Error(json.error);
            }

            const lastUpdated = Date.now();

            if(!isEqual(json.results, usergroups)) {
                _setUsergroups(json.results);
            }

            localStorage.setItem(localStorageKey, JSON.stringify({
                lastUpdated,
                results: json.results,
            }));
            _setLastUpdated(lastUpdated);
        } catch (error) {
            console.error("useUsergroupManagemenet.reloadUsers error", error);
        }
    }
    const usergroupHasRole = (usergroup, requestedRole) => {
        let roles = usergroup.roles
        if (!roles) {
            return false
        }
        let index = roles.findIndex(function (role) {
            if( role.code === requestedRole ) {
                return true
            }
            let index = roles.findIndex(function (role) {
                if( role.code === requestedRole ) {
                    return true
                }
                if( role.code === 'full_access_admin' ) {
                    return true
                }
                if( role.implied_rule_codes ) {
                    let impliedIndex = role.implied_rule_codes.findIndex(function (impliedRoleCode) {
                        return impliedRoleCode === requestedRole
                    })
                    if( impliedIndex >= 0 ) {
                        return true
                    }
                }
                return false
            })
            return index >= 0 ? true : false
        })
    }

    const usergroupHasProjectAccess = (usergroup, projectID) => {
        const access = usergroup.usergroup_project_access || []
        if (access.some(a => a.project_id === projectID)) {
            return true
        }
        return false
    }

    const usergroupProjectAccessLevel = (usergroup, projectID) => {
        const access_level = usergroup.usergroup_project_access.find(function (a) { return a.project_id === projectID || ( isNaN(projectID) && isNaN(a.project_id) ) })
        return access_level
            ? access_level.user_project_access_level_id
                : 0
    }
    
    return {
        usergroups,
        updateUsergroup,
        saveUsergroupUpdates,
        reloadUsergroups: fetchData,
        usergroupHasProjectAccess,
        usergroupHasRole,
        usergroupProjectAccessLevel,
    }
}
export default useUsergroupManagement
